import { Controller } from "@hotwired/stimulus"

// Переключатель «Готов к производству» на странице результата.
// При отказе сервера возвращает переключатель в прежнее положение.
export default class extends Controller {
  static values = { url: String }
  static targets = ["checkbox"]

  async toggle() {
    const enabled = this.checkboxTarget.checked
    this.checkboxTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Accept": "application/json"
        },
        body: JSON.stringify({ enabled })
      })
      const data = await response.json()

      if (!data.success) {
        this.checkboxTarget.checked = !enabled
        window.alert(data.error)
      }
    } catch (error) {
      this.checkboxTarget.checked = !enabled
      window.alert(`Ошибка запроса: ${error.message}`)
    } finally {
      this.checkboxTarget.disabled = false
    }
  }
}
